module.exports = __webpack_public_path__ + "static/media/corporate.0d77d35f.svg";